import Cookies from 'js-cookie';
import { host, href, search } from 'core-framework/window/location';
import { EnsightenEventConfig } from 'core/type/behaviors.types';
import axios from 'axios';
import { getCronosHeader } from 'core/utils/cronosHeader';
import { UserMenuViewModel } from '@agoda/layout/lib/framework/model/layout';

interface EnsightenEvent {
    action_type: string;
    evarpagename: string;
    site_events: string;
    page_type: string;
    form_type: string;
    citi_travel_search_term: string;
    internal_search_count: number;
    pid: string;
    page_inter: string;
    internal_campaign_tracking_id: string;
    url: string;
    s_vi: string;
    domain: string;
    inline_message: string;
    external_campaign_tracking_id: string;
    dynamic_cont_appr: string;
    test_id: string;
}

const getCookie = (cookieName: string): string => {
    const cookie: string | undefined = Cookies.get(cookieName);
    return !cookie ? '' : cookie;
};

const getPromoBannerText = (): string =>
    document.querySelector("[data-element-name='lazy-earn-accelerator-banner-container'] .bold-booking")?.parentElement?.innerText.trim() || '';

const getUserViewModel = () => {
    return axios<UserMenuViewModel>({
        url: '/api/cronos/layout/PageHeaderApi/UserMenuViewModel',
        headers: getCronosHeader(),
        method: 'GET',
    })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            // Do nothing
        });
};

const generateEvent = async (searchTerm: string, totalActivities: number, eventConfig: EnsightenEventConfig): Promise<EnsightenEvent> => {
    const urlSearchParams: URLSearchParams = new URLSearchParams(search());
    const getQueryParam = (param: string): string => {
        return urlSearchParams.get(param) || '';
    };

    const userVM = await getUserViewModel();

    return {
        action_type: eventConfig?.actionType,
        evarpagename: eventConfig?.evarpagename,
        site_events: eventConfig?.siteEvents,
        page_type: eventConfig?.pageType,
        form_type: '',
        citi_travel_search_term: `location=${searchTerm}`,
        internal_search_count: totalActivities,
        pid: userVM?.partnerLoyaltyMenuViewModel?.partnerLoyaltyCardName || '',
        page_inter: '',
        internal_campaign_tracking_id: getQueryParam('intc'),
        url: href(),
        s_vi: getCookie('s_vi'),
        domain: host(),
        inline_message: eventConfig?.inlineMessage,
        external_campaign_tracking_id: getQueryParam('cmp'),
        dynamic_cont_appr: getPromoBannerText(),
        test_id: eventConfig?.testId,
    };
};

export const injectEnsightenTags = async (searchTerm = '', totalActivities = 0, eventConfig: EnsightenEventConfig): Promise<void> => {
    if (!Object.keys(window).includes('_dl')) {
        const event: EnsightenEvent = await generateEvent(searchTerm, totalActivities, eventConfig);
        const script = document.createElement('script');
        script.type = 'text/javascript';

        // nosemgrep: insecure-document-method
        script.append(`window._dl = ${JSON.stringify(event)};`);
        script.append(`
         window._trackAnalytics = window._trackAnalytics || function(a) {
            window.stored_analytics = window.stored_analytics || [];
            window.stored_analytics.push(a);
         };
         window._trackAnalytics(window._dl);
         `);
        document.head.appendChild(script);
    }
};
